import {STORE_CHANNEL} from '../../constants';

const initialState = {
  fetchPage: null
}

export default function channels(state = initialState, action) {
  const {type, ...rest} = action;

  switch (type) {
    case STORE_CHANNEL:
      return {
        ...state,
        [rest.name]: rest
      }
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/store/reducers/channels.js
 **/